import { useMemo } from 'react';
import { t } from 'i18next';

// Domain
import { buildJsonDownloadFileName, formatJsonCode } from '../../../domain/dashboardCode/dashboardCodeUseCase';

// Utils
import { downloadTextFile } from '../../../utils/download';

// Components
import Button from '../../atoms/Button/Button';
import CodeBlock from '../../atoms/CodeBlock/CodeBlock';
import MarkdownContainer from '../../atoms/MarkdownContainer/MarkdownContainer';

// Styles
import styles from './DashboardItemCode.module.css';

/**
 * DashboardItemCode component - Displays a code dashboard item (pretty printed JSON or markdown)
 * @param {object} props
 * @param {string} props.id - Item id (used as download file name)
 * @param {'json' | 'markdown'} props.type - Code language
 * @param {string} props.value - Raw code content
 * @returns {JSX.Element}
 */
function DashboardItemCode({ id, type, value }) {
  const { formatted } = useMemo(() => formatJsonCode(type === 'json' ? value : ''), [type, value]);

  if (type === 'markdown') {
    return <MarkdownContainer content={value} className={styles['dashboard-item-code-markdown']} />;
  }

  const handleDownload = () => {
    downloadTextFile(formatted, buildJsonDownloadFileName(id), 'application/json');
  };

  return (
    <div className={styles['dashboard-item-code']}>
      <Button
        color="no-background"
        size="small"
        icon="fas fa-download"
        onClick={handleDownload}
        disabled={!formatted}
      >
        {t('dashboard.code.downloadJson')}
      </Button>
      <CodeBlock code={formatted} />
    </div>
  );
}

export default DashboardItemCode;
